<template>
    <div v-if="data">
        <div class="block is-inline-flex">
            <p class="is-size-2 has-text-weight-bold">
                Meetings {{name}}
            </p>
            <div class="buttons m-l-md">
                <b-button @click="isCreate=true" class="is-uppercase">
                    Make point
                </b-button>
            </div>
        </div>
        <div class="block">
            <div class="card">
                <div class="card-content">
                    <div class="columns">
                        <div class="column is-half">
                            <b-field label="Name">
                                <b-input v-model="data.attributes.name">
                                </b-input>
                            </b-field>
                            <b-field label="Client">
                                <b-select v-model="data.attributes.client_user_id" placeholder="Enter client">
                                    <option :value="client.id" v-for="(client,key) in clients" :key="key">{{client.attributes.email}}</option>
                                </b-select>
                            </b-field>
                            <div class="block">
                                <b-field label="Archive?">
                                    <b-switch v-model="data.attributes.archived_at"
                                        :true-value="true"
                                        :false-value="null"
                                        type="is-danger"
                                        passive-type="is-success">
                                    </b-switch>
                                </b-field>
                            </div>
                        </div>
                    </div>
                    <section class="m-t-md">
                        <router-link :to="{ name: 'meetings'}" class="button is-default m-r-sm">Cancel</router-link>
                        <b-button type="is-success m-r-sm" @click.prevent="save">Save</b-button>
                    </section>
                </div>
            </div>
        </div>
        <div class="block">
            <div class="card">
                <div class="card-content">
                    <b-table
                    :data="points.length>1 || isCreate ? points : []"
                    :columns="columns"
                    >
                        <template slot-scope="props">
                            <b-table-column v-if="props.row.create && isCreate">
                            </b-table-column>
                            <b-table-column v-if="props.row.create && isCreate">
                                <b-input v-model="props.row.name" placeholder="Enter name">
                                </b-input>
                            </b-table-column>
                            <b-table-column v-if="props.row.create && isCreate">
                                <b-input type="textarea" v-model="props.row.details" placeholder="Enter details *">
                                </b-input>
                            </b-table-column>
                            <b-table-column v-if="props.row.create && isCreate">
                            </b-table-column>
                            <b-table-column v-if="props.row.create && isCreate">
                                <b-select v-model="props.row.app_id" placeholder="Select app">
                                    <option selected disabled>Select app *</option>
                                    <option :value="app.id" v-for="(app,key) in apps" :key="key">{{app.name}}</option>
                                </b-select>
                            </b-table-column>
                            <b-table-column v-if="props.row.create && isCreate">
                                <b-input v-model="props.row.action_for" placeholder="Enter action for">
                                </b-input>
                            </b-table-column>
                            <b-table-column v-if="props.row.create && isCreate">
                                <span>
                                    <div class="buttons">
                                        <b-button type="is-success" size="is-small" position="is-right" class="m0" @click="createPoint">
                                            Save
                                        </b-button>
                                        <b-button type="is-danger" size="is-small" position="is-right" class="m0" @click="isCreate=false">
                                            Cancel
                                        </b-button>
                                    </div>
                                </span>
                            </b-table-column>
                            
                            <b-table-column v-if="!props.row.create">
                                <span>
                                    {{props.row.id}}
                                </span>
                            </b-table-column>
                            <b-table-column v-if="!props.row.create">
                                <span>
                                    {{props.row.attributes.name}}
                                </span>
                            </b-table-column>
                            <b-table-column v-if="!props.row.create">
                                <span>
                                    {{props.row.attributes.details}}
                                </span>
                            </b-table-column>
                            <b-table-column v-if="!props.row.create">
                                <span>
                                    {{props.row.attributes.created_by}}
                                </span>
                            </b-table-column>
                            <b-table-column v-if="!props.row.create">
                                <span>
                                    {{props.row.attributes.app_id}}
                                </span>
                            </b-table-column>
                            <b-table-column v-if="!props.row.create">
                                <span>
                                    {{props.row.attributes.action_for}}
                                </span>
                            </b-table-column>
                            <b-table-column v-if="!props.row.create">
                                <span>
                                    <div class="buttons">
                                        <b-button size="is-small" 
                                        @click="goTo('tickets.create',null,{point:props.row.id})">
                                            Create Ticket
                                        </b-button>
                                        <b-button type="is-primary" size="is-small" position="is-right" class="m0" 
                                            @click="goTo('points.edit',{
                                                meetingId: data.id,
                                                id:props.row.id
                                            })" 
                                            icon-left="pencil"/>
                                        <b-button type="is-danger" size="is-small" position="is-right"  class="m0" @click="deletePoint(props.row)" icon-left="trash-can"/>
                                    </div>
                                </span>
                            </b-table-column>
                        </template>
                        <template slot="empty">
                            <section class="section">
                                <div class="content has-text-grey has-text-centered">
                                    <p>
                                        <b-icon icon="alert-decagram-outline" size="is-large"></b-icon>
                                    </p>
                                    <p>NO RESULTS FOUND</p>
                                </div>
                            </section>
                        </template>
                    </b-table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import _ from 'lodash';
import Vue from 'vue';

export default {
    data() {
        return {
            data:null,
            name:null,
            points:[
                {
                    create: true,
                    name: null,
                    details: null,
                    action_for: null,
                    app_id:null
                }
            ],
            isCreate:false,
            columns:[
                {
                    label:'Id',
                    field:'id',
                },
                {
                    label:'Name',
                    field:'name',
                },
                {
                    label:'Details',
                    field:'details',
                },
                {
                    label:'Created By',
                    field:'created_by',
                },
                {
                    label:'App',
                    field:'app',
                },
                {
                    label:'Action For',
                    field:'action_for',
                },
                {
                    label:'Actions',
                    field:'action',
                },
            ],
            clients:[],
            page:1,
            editId:null
        }
    },
    computed:{
        id() {
            return this.$router.currentRoute.params.id
        },
    },
    async mounted() {
        await this.getApps()
        await this.getMeeting()
        await this.getClients()
    },
    methods: {
        getApps() {
            Vue.$appService.appList().then((response)=>{
                this.apps = response
            })
        },
        getMeeting(){
            Vue.$meetingService.getMeeting(this.id).then((response)=>{
                this.data = response.data
                this.name=response.data.attributes.name
                this.points[0].meeting_id = response.data.id
                this.getPoints()
            }).catch(()=>{
                this.$router.push({name:'meetings'})
            });
        },
        getClients() {
            Vue.$userService.userList('?roles=gatekeeper').then((response)=>{
                this.clients = response.data
            })
        },
        save() {
            Vue.$meetingService.updateMeeting(this.id,this.data.attributes).then((response)=>{
                this.data = response.data
                this.data.attributes.archived_at = this.data.attributes.archived_at ? true : false
                this.$buefy.toast.open({
                    type:'is-success',
                    message:'Meeting saved!'
                })
            });
        },
        createPoint() {
            Vue.$pointService.createPoint(this.points[0]).then((response)=>{
                this.points.unshift(response.data)
                this.$buefy.toast.open({
                    type: 'is-success',
                    message: 'Meeting added!'
                })
                this.points = _.filter(this.points,(value)=>{
                    return value.create ? false : true
                })
                this.points.unshift({
                    create: true,
                    name: null,
                    details: null,
                    action_for: null,
                    meeting_id:this.data.id,
                    app_id:null
                })
                this.isCreate = false
            })
        },
        getPoints() {
            Vue.$pointService.pointList(`?page=${this.page}&meeting_id=${this.data.id}`).then((response)=>{
                this.page++;
                this.points.push(...response.data)
                if(response.data.length==0){
                    this.isCreate=true;
                }
            })
        },
        deletePoint(row) {
            this.$buefy.dialog.confirm({
                title: 'Deleting point',
                message: 'Are you sure you want to <b>delete</b> this point? This action cannot be undone.',
                confirmText: 'Delete Point',
                type: 'is-danger',
                hasIcon: true,
                onConfirm: () => {
                    Vue.$pointService.delete(row.id).then(()=>{
                        this.$buefy.toast.open({
                            type: 'is-success',
                            message: 'Point deleted!'
                        });
                        let id = row.id;
                        this.points = _.filter(this.points,(value)=>{
                            return value.id!==id
                        });
                    })
                }
            });
        },
        goTo(name,params=null,query=null){
            let route = {name:name}
            if(params) {
                route['params'] = params
            }
            if(query) {
                route['query'] = query
            }
            this.$router.push(route);
        }
    }
}
</script>